import { adminBaseAPI } from "../../AdminBaseAPI";
import { SERVICE_TAG_TYPES } from "../../Constants";
import {
  IAbsorbLmsLogin,
  IApplication,
  IMyDetailsEditRequest,
  IPaginatedList,
  ISearchParam,
  IUser,
} from "Common/Interfaces";

const controller = "users";
export const adminUsersAPI = adminBaseAPI.injectEndpoints({
  endpoints: (build) => ({
    getMyDetails: build.query<IUser, void>({
      query: () => `${controller}/me`,
      transformResponse: (response: IUser) => response,
      providesTags: (result) => (result ? [{ type: SERVICE_TAG_TYPES.USER_DETAILS, id: "OBJECT" }] : []),
    }),
    getUserApplications: build.query<IPaginatedList<IApplication>, ISearchParam>({
      query: ({ offset, limit, sortBy, orderBy, search }) =>
        `users/applications?Offset=${offset}&Limit=${limit}&SortBy=${sortBy}&OrderBy=${orderBy}&IsDeleted=false&Search=${search}`,
      transformResponse: (response: IPaginatedList<IApplication>) => {
        return { ...response, data: response.data.map((x) => ({ ...x, key: x.id })) };
      },
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: SERVICE_TAG_TYPES.USER_APPLICATIONS, id } as const)),
              { type: SERVICE_TAG_TYPES.USER_APPLICATIONS, id: "LIST" },
            ]
          : [],
    }),
    getAbsorbLmsLogin: build.query<IAbsorbLmsLogin, void>({
      query: () => `${controller}/me/absorb-lms-login`,
      transformResponse: (response: IAbsorbLmsLogin) => response,
      providesTags: (result) => (result ? [{ type: SERVICE_TAG_TYPES.ABSORB_LMS, id: "LOGIN" }] : []),
    }),
    updateMyDetails: build.mutation<IUser, IMyDetailsEditRequest>({
      query(userDetails) {
        return {
          url: `${controller}/me`,
          method: "PUT",
          body: userDetails,
        };
      },
      transformResponse: (response: IUser) => response,
      invalidatesTags: (result) => (result ? [{ type: SERVICE_TAG_TYPES.USER_DETAILS, id: "OBJECT" }] : []),
    }),
  }),

  overrideExisting: false,
});

export const { useGetMyDetailsQuery, useGetUserApplicationsQuery, useLazyGetAbsorbLmsLoginQuery } = adminUsersAPI;
